import { useContext, useState } from 'react';

import { Col, Row } from 'react-bootstrap';
import Button from '../../core/components/buttons/Button';
import { FormContext, PhoneInput, SubmitButton } from '../../core/components/forms';
import Form from '../../core/components/forms/Form';
import { clientContactPhoneValidationSchema } from '../validation';

// interface ContactPhoneFieldProps {
//   field?: string
//   disabled?: boolean
// }

const ContactPhoneField = props => {
  const { field, disabled } = props;

  const { values, setFieldValue } = useContext(FormContext);
  const [editMode, setEditMode] = useState(false);

  const input = (
    <Form
      initialValues={ {} }
      validationSchema={ clientContactPhoneValidationSchema }
      onSubmit={ val => {
        setFieldValue(field, val.phone);setEditMode(false);
      } }
    >
      <Row>
        <Col md={ 3 }>
          <PhoneInput name='phone' />
        </Col>
        <Col md={ 2 }>
          <SubmitButton />
        </Col>
      </Row>
    </Form>
  );

  const manage = values[field] ? (
    <>
      <b>{ values[field] }</b>
      <Button
        icon='close'
        onClick={ () => setFieldValue(field, '') }
        disabled={ disabled }
      />
    </>
  ) : (
    <Button
      variant='primary'
      onClick={ () => setEditMode(true) }
      disabled={ disabled }
    >
      Добавить телефон
    </Button>
  );

  return (
    <li className='mt-1'>
      { editMode ? input : manage }
    </li>
  );
};

export default ContactPhoneField;
